import {Data} from 'containers/GoneTableFrame/Container';
import 'containers/GoneTableFrame/index.scss';
import React, {FC} from 'react';
import {flatBem} from 'utils/bem';
import {Configurator} from 'utils/makeConfigurator';
import {capitalize, ensureEndsWithDot} from 'utils/string';

const b = flatBem('GoneTableFrame');

export type TableRow = {
  word: string;
  meaning: string;
  example: string;
  year: string;
};

type Props = {
  data: Data;
  conf: Configurator;
};

const Component: FC<Props> = ({data, conf}) => {
  // console.log(conf('isMobile', false), data);
  const isMobile = conf('isMobile', false);
  return (
    <div className={b()}>
      <div className={b('title')}>Сто уходящих и ушедших слов</div>
      <div className={b('text-after-title')}>
        Примеры слов, частотность которых в дневниковых записях первых сорока лет XX века была как
        минимум в 10 раз выше, чем в статьях и комментариях в современных блогах.
      </div>
      <div className={b('table')}>
        <div className={b(['table-header', 'table-row'])}>
          <div className={b(['header-cell', 'column-old-cell', 'table-cell'])}>Уходящее слово</div>
          <div className={b(['header-cell', 'column-new-cell', 'table-cell'])}>
            Современный аналог
          </div>
          <div className={b(['header-cell', 'column-example-cell', 'table-cell'])}>
            Пример использования
          </div>
        </div>
        <div className={b('table-body')}>
          {data.tableRows.map(
            ({word: oldWord, meaning: newWord, example: examplePhrase, year: exampleYear}) => (
              <div className={b(['table-body-row', 'table-row'])} key={oldWord}>
                {isMobile ? (
                  <>
                    <div className={b('mobile-old-new-cell')}>
                      <span className={b('mobile-old-cell')}>{capitalize(oldWord)}</span>{' '}
                      <span className={b('mobile-new-cell')}>
                        (современный аналог &mdash; {capitalize(newWord)})
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className={b(['table-cell', 'column-old-cell'])}>
                      {capitalize(oldWord)}
                    </div>
                    <div className={b(['table-cell', 'column-new-cell'])}>
                      {capitalize(newWord)}
                    </div>
                  </>
                )}
                <div className={b(['table-cell', 'column-example-cell'])}>
                  <div
                    className={b(['example-phrase'])}
                    dangerouslySetInnerHTML={{__html: ensureEndsWithDot(examplePhrase)}}
                  />
                  <div className={b(['example-year'])}>{exampleYear}</div>
                </div>
              </div>
            ),
          )}
        </div>
      </div>
      <div className={b('copyright')}>
        <div className={b('copyright-left')}>
          По данным Яндекс.Дзена, 2019–2021, и центра <a href="">Прожито</a> ЕУСПб, 1900–1940.
        </div>
        <div className={b('copyright-mid')} />
        <div className={b('copyright-right')}>
          <a href="https://milab.s3.yandex.net/2021/old-words/data/RussianOldWordsDataset.zip">
            Скачать таблицу
          </a>{' '}
          с 1000 уходящих и ушедших слов
        </div>
      </div>
    </div>
  );
};

export default Component;
